import { AsciiText } from '../framework/AsciiText';
export class StewartAudio {
    constructor(socket, log) {
        this.socket = socket;
        this.channels = [
            { name: 'Output 1', mute: false, volume: 50 },
            { name: 'Output 2', mute: false, volume: 50 },
            { name: 'Output 3', mute: false, volume: 50 },
            { name: 'Output 4', mute: false, volume: 50 },
        ];
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /^\x12\x13\x13/,
                callback: (match) => {
                    this.socket.send(`PIC firmware is v3.1-DSP4x4\r`);
                    return;
                },
            },
            {
                name: 'muteGet',
                regExp: /^\x12\x11([\s\S])/,
                callback: (match) => {
                    const channelNumber = match[1].charCodeAt(0);
                    const channel = this.channels[channelNumber - 1];
                    this.socket.send(this.makeCommand([0x06, channel.mute ? 1 : 0]));
                },
            },
            {
                name: 'muteSet',
                regExp: /^\x12(\x08|\x09)([\s\S])/,
                callback: (match) => {
                    const channelNumber = match[2].charCodeAt(0);
                    this.channels[channelNumber - 1].mute = match[1].charCodeAt(0) === 0x08;
                    this.socket.send(this.makeCommand([0x06, this.channels[channelNumber - 1].mute ? 1 : 0]));
                },
            },
            {
                name: 'volumeGet',
                regExp: /^\x12\x07([\s\S])/,
                callback: (match) => {
                    const channelNumber = match[1].charCodeAt(0);
                    const channel = this.channels[channelNumber - 1];
                    this.socket.send(this.makeCommand([0x06, channel.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /^\x12\x06([\s\S])([\s\S])/,
                callback: (match) => {
                    const channelNumber = match[1].charCodeAt(0);
                    this.channels[channelNumber - 1].volume = match[2].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x06, this.channels[channelNumber - 1].volume]));
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    // No response to invalid commands
                },
            },
        ];
        this.sendTerminator = '\n'; // 0x0a
    }
    commandExtractor(buffer) {
        for (let i = 0; i < buffer.length; i++) {
            // Commands are at least 4 characters.
            // The terminator (0x03) can also appear as a channel number or level value.
            // Example valid commands: 12 06 03 03 03, 12 13 13 03
            // We consider 0x03 a terminator if it is at or beyond index 3 and if there is more data
            // in the buffer and the next character is not 0x03 due to starting a new command, or if
            // there is no more data.
            if (i >= 3 &&
                buffer.charCodeAt(i) === 0x03 &&
                ((i < buffer.length - 1 && buffer.charCodeAt(i + 1) !== 0x03) ||
                    i === buffer.length - 1)) {
                const command = buffer.slice(0, i);
                buffer = buffer.slice(i + 1);
                return { command, buffer };
            }
        }
        return undefined;
    }
    makeCommand(data) {
        return AsciiText.decode(data);
    }
}
StewartAudio.emulatorType = 'socketEmulator';
StewartAudio.key = '-MotrnMQ-p5ERBXqSb86';
